var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.1609C24.0615 18.1609 27.354 14.8684 27.354 10.8069C27.354 6.74538 24.0615 3.45288 20 3.45288C15.9385 3.45288 12.646 6.74538 12.646 10.8069C12.646 14.8684 15.9385 18.1609 20 18.1609Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.385 36.5469C38.385 26.3929 30.154 18.1619 20 18.1619C9.84599 18.1619 1.61499 26.3929 1.61499 36.5469",
    stroke: "white",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default ForwardRef;